module.exports = __webpack_public_path__ + "static/img/active5.859cc791.png";